import reducers from "./StethIOReviewReducer";

export default reducers;